export default "__VITE_ASSET__0NOVTB_W__"